import "core-js/modules/web.dom.iterable";
//
//
//
//
//蓝天日历
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-50px'
    },
    left: {
      type: String,
      default: '20px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {},
  methods: {
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    getVirtulData: function getVirtulData(year, month, dateData) {
      var dates = year + '-' + month + '-' + '1';
      var today = Date.parse(new Date(dates));
      var dayTime = 3600 * 24 * 1000;
      var thatday = today + dayTime * this.getDaysInOneMonth(year, month);
      var data = [];

      for (var time = today; time < thatday; time += dayTime) {
        data.push([echarts.format.formatTime('yyyy-MM-dd', time), 5]);
      }

      for (var i = 0; i < data.length; i++) {
        data[i][1] = dateData[i];
      }

      console.log('data', data);
      return {
        data: data,
        today: echarts.format.formatTime('yyyy-MM-dd', today),
        thatday: echarts.format.formatTime('yyyy-MM-dd', thatday)
      };
    },
    initBarChart: function initBarChart() {
      var _this = this;

      var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '2023-03';
      var datas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
      var maxArr = []; // let month = new Date(time).getMonth() + 1; //获取当前月
      // var year = new Date(time).getFullYear(); //获取当前年
      // var datas = []; //新建日期数组
      // var dataLength = new Date(year, month).toJSON().substring(0, 10).split('-')[2]; //获取当前年月日期最大值
      // for (var i = 0; i < Number(dataLength); i++) {
      //   let months = month >= 10 ? month : '0' + month;
      //   let day = i + 1 >= 10 ? i + 1 : '0' + (i + 1);
      //   datas.push({ date: year + '-' + months + '-' + day, total: Math.floor(Math.random() * 100) }); //存入数组
      // }

      var chartData = [];
      datas.forEach(function (item) {
        maxArr.push(item.total);
        chartData.push({
          value: [item.date, item.total]
        });
      });
      var thisMonth = time; //当前月份

      var option = {
        tooltip: {
          backgroundColor: '#3A5B90',
          textStyle: {
            color: '#fff',
            fontSize: 10
          },
          formatter: function formatter(params) {
            return '巡检次数: ' + params.value[1];
          }
        },
        visualMap: {
          min: 0,
          max: max,
          inRange: {
            color: ['#ccc', '#86e0ef', '#1780AC']
          },
          show: false,
          top: '10%',
          textStyle: {
            color: '#fff'
          },
          left: -5
        },
        calendar: {
          cellSize: ['auto', 32],
          left: '10%',
          right: '10%',
          top: '10%',
          orient: 'vertical',
          range: [thisMonth],
          itemStyle: {
            borderColor: '#060F2C',
            borderWidth: 1
          },
          splitLine: {
            show: false
          },
          yearLabel: {
            show: false
          },
          monthLabel: {
            show: false
          },
          dayLabel: {
            firstDay: 1,
            margin: 5,
            nameMap: 'cn',
            textStyle: {
              color: '#fff',
              fontSize: 10
            }
          }
        },
        series: [{
          type: 'scatter',
          coordinateSystem: 'calendar',
          symbolSize: 1,
          label: {
            normal: {
              show: true,
              formatter: function formatter(params) {
                var d = echarts.number.parseDate(params.value[0]);
                return d.getDate();
              },
              textStyle: {
                color: '#fff',
                fontSize: 12,
                textShadowColor: '#0B1131',
                textShadowBlur: 0,
                textShadowOffsetX: 1,
                textShadowOffsetY: 1
              }
            }
          },
          data: chartData
        }, {
          type: 'heatmap',
          coordinateSystem: 'calendar',
          data: chartData
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      myChart.on('click', function (param) {
        console.log(param);

        if (title) {
          _this.$emit('content', title[param.value[1]], param.value[0]);
        }
      });
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};